import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class FulfillmentLineStepsStatusTagComponent implements IController {

  fulfillmentLineSteps: any;
  maxSteps: any;


  public fulfillmentLineStepsView: any;
  public extraFulfillmentLineStepsCount: any = undefined;
  public fulfillmentStepsMissingPackagesCountMap: any = {};

  constructor() {
  }

  $onInit() {
    this._initFulfillmentLineSteps(this.fulfillmentLineSteps);
    this._initFulfillmentLineStepsMissingPackages();
  }

  private _initFulfillmentLineSteps(fulfillmentLineSteps) {
    this.fulfillmentLineStepsView = this.maxSteps ? _.filter(fulfillmentLineSteps, (item, index) => {
      return index <= this.maxSteps;
    }) : fulfillmentLineSteps;

    if (fulfillmentLineSteps.length > this.fulfillmentLineStepsView.length) {
      this.extraFulfillmentLineStepsCount = '+' + (fulfillmentLineSteps.length - this.fulfillmentLineStepsView.length).toString();
    }
  }

  private _initFulfillmentLineStepsMissingPackages() {
    _.forEach(this.fulfillmentLineSteps, s => {
      this.fulfillmentStepsMissingPackagesCountMap[s.id] = _.reduce(s.items, (sum, i) => {
        if (i.actualCount) {
          return sum + (i.count - i.actualCount);
        }
      }, 0);
    })
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineStepsStatusTag', {
    bindings: {
      fulfillmentLineSteps: '<',
      maxSteps: '<'
    },
    template: require('./fulfillment-line-steps-status-tag.html').default,
    controller: FulfillmentLineStepsStatusTagComponent
  });
